import { useEffect } from "react";

import "./USCitizenBlock.scss";

const US_CITIZEN_BLOCK_ID = "us-citizen-block";

const USCitizenBlock = () => {
  useEffect(() => {
    // Hide the footer-wrapper when this component is mounted
    const footer = document.querySelector(".footer-wrapper");
    const outletBlock = document.querySelector(".outlet-block");
    if (footer && outletBlock) {
      footer.style.display = "none";
      outletBlock.style.backgroundColor = "transparent";
    }
    return () => {
      // Restore the footer when this component is unmounted
      if (footer && outletBlock) {
        footer.style.display = "";
        outletBlock.style.backgroundColor = "#232854";
      }
    };
  }, []);

  return (
    <div id={US_CITIZEN_BLOCK_ID} className="us-citizen-block">
      <h3 className="us-citizen-block__title">
        Domiciled in the United States?
      </h3>
      <p className="us-citizen-block__description">
        Zimtra is currently unavailable to US residents.
        <br />
        We have an agreement with{" "}
        <a
          className="us-citizen-block__link"
          href="https://bit.ly/461TOQT"
          target="_blank"
          rel="noopener noreferrer"
        >
          SageTrader
        </a>
        , a FINRA Broker Dealer accepting US clients.
      </p>
      <div className="us-citizen-block__image-wrapper">
        <img
          src={process.env.PUBLIC_URL + "/sage_vector.svg"}
          alt="SageTrader"
        />
        <img
          src={process.env.PUBLIC_URL + "/zimtra_logo.svg"}
          alt="Zimtra"
        />
      </div>
    </div>
  );
};

export default USCitizenBlock;
